package org.hs_soft.runmynesto.domain.model.home.product.products_list_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListProducts(
    @SerialName("cursors")
    val cursors: Cursors?,
    @SerialName("hasNextPage")
    val hasNextPage: Boolean?,
    @SerialName("items")
    val items: List<ProductItem>,
    @SerialName("total")
    val total: Int?,
    @SerialName("__typename")
    val typename: String?
)